import request from "@/utils/request";

export function queryOrg (params){
  return request({
    url:'/osp/org-storage/getCompanyAndReposOrg',
    method:'get',
    params: params
  })
}
